//Common Page Start
import { Route, Routes } from "react-router-dom";
import SecureRoute from "./SecureRoute";
import { useCookies } from "react-cookie";
import { PageUrl } from "../../utils/app-config";
import EServices from "../../pages/Home/EServices";
import Feedback from "../../components/molecules/Feedback";
import UserGuides from "../../components/molecules/Footer/UserGuides";
import RatingFeedback from "../../components/molecules/RatingFeedback";
import NotFound from "../../pages/Common/notfound";
import { decryptData } from "../../utils/encryptionhelper";
import { useConfig } from "../../context/ConfigProvider";
//Common Page End

//Payment Module Start
import PaymentDashboard from "../../pages/Payment/PaymentDashboard";
import Payments from "../../pages/Payment/CardForm";
import Success from "../../pages/Payment/PaymentSuccess";
import PaymentFailed from "../../pages/Payment/PaymentFailed";
import TradenetPayments from "../../pages/Payment/CardPaymentForm";
//Payment Module End

//Microchip Module Start
import ApplicationForImportPermit from "../../pages/Application/LicenseApplication/ApplicationForImportPermit";
import ApplicationForMembership from "../../pages/Application/LicenseApplication/ApplicationForMembership";
import ApplicationForBirds from "../../pages/Application/BirdsApplication/ApplicationForBirds";
import SingleRegComplete from "../../pages/Complete/SingleRegComplete";
import ApplicationForPets from "../../pages/Application/PetsApplication/ApplicationForPets";
import PetsDashboard from "../../pages/DashBoard/Microchip/Pets/PetsDashboard";
//Microchip Module End

//Inspection/Harvest Module Start
import ApplicationForInspection from "../../pages/Inspection/ApplicationForInspection";
import InspectionDashboard from "../../pages/DashBoard/Inspection/InspectionDashboard";
import ISRInspectionDashboard from "../../pages/DashBoard/ISRInspection/ISRInspectionDashboard";
import ISRInspection from "../../pages/Inspection/ISRInspection";
import VetHealthInspection from "../../pages/Inspection/VetHealthInspection";
import VetHealthInspectionDashboard from "../../pages/DashBoard/Inspection/VetHealthInspectionDashboard";
import VetHealthInspectionComplete from "../../pages/Complete/VetHealthInspectionComplete";
import HarvestDetailsDashboard from "../../pages/DashBoard/Harvest/HarvestDetailsDashboard";
import HarvestDetails from "../../pages/HarvestDetails/HarvestDetails";
import HarvestDetailsRegistration from "../../pages/HarvestDetails/HarvestDetailsRegistration";
import HarvestDetailsApplicationComplete from "../../pages/Complete/HarvestDetailsApplicationComplete";
import HarvestInspectionComplete from "../../pages/Complete/HarvestInspectionComplete";
//Inspection/Harvest Module End

//Login/Account Module Start
import CorppassLogin from "../../pages/login/corppass-login";
import MyInfoLogin from "../../pages/login/myinfo-login";
import Auth from "../../pages/login/auth";
import Login from "../../pages/login/login";
import AuthCallbackCP from "../../pages/login/cp-callback";
import MIAuthCallback from "../../pages/login/mi-callback";
import ForgetPassword from "../../pages/login/forgetpassword";
import MyProfile from "../../pages/Profile/profile";
import ForceChangePassword from "../../pages/Profile/force-change-password";
import ResetPassword from "../../pages/Profile/reset-password";
import AccountRegistration from "../../pages/Registration/account-registration";
import AccountSuccess from "../../pages/Registration/account-success";
//Login/Account Module End

//SFA Page Start
import SfaRegistration from "../../pages/sfa/sfa-registration";
import SfaSuccess from "../../pages/sfa/sfa-success";
//SFA Page End

//Lab Module Start
import ChooseApplication from "../../pages/LabDetails/ChooseApplication";
import SamplesAndTests from "../../pages/LabDetails/SamplesAndTests";
import ProjectDetails from "../../pages/LabDetails/ProjectDetails";
import CostAndConfirm from "../../pages/LabDetails/CostAndConfirm";
import AnimalPurposeCode from "../../pages/LabDetails/AnimalPurposeCode";
import BioSamplesAndTest from "../../pages/LabDetails/CAVSBioSamplesAndTests";
import AquaSamplesAndTest from "../../pages/LabDetails/CAVSAquaSamplesAndTests";
import Review from "../../pages/LabDetails/Review";
import CAVSBioReview from "../../pages/LabDetails/CAVSBioReview";
import Acknowledgement from "../../pages/LabDetails/Acknowledgement";
import CAVSAVISampleDetails from "../../pages/LabDetails/CAVSAVISampleDetails";
import CAVSENVSampleDetails from "../../pages/LabDetails/CAVSENVSampleDetails";
import CAVSFRWSampleDetails from "../../pages/LabDetails/CAVSFRWSampleDetails";
import CAVSTERSampleDetails from "../../pages/LabDetails/CAVSTERSampleDetails";
import CAVSBioCostAndConfirm from "../../pages/LabDetails/CAVSBioCostAndConfirm";
import CAVSBioAcknowledgement from "../../pages/LabDetails/CAVSBioAcknowledgement";
import CAVSAquaReview from "../../pages/LabDetails/CAVSAquaReivew";
import CAVSAquaCostAndConfirm from "../../pages/LabDetails/CAVSAquaCostAndConfirm";
import CAVSAquaAcknowledgement from "../../pages/LabDetails/CAVSAquaAcknowledgement";
import CAVSAVIAcknowledgement from "../../pages/LabDetails/CAVSAVIAcknowledgement";
import CAVSAVIReview from "../../pages/LabDetails/CAVSAVIReview";
import CAVSENVReview from "../../pages/LabDetails/CAVSENVReview";
import CAVSTERReview from "../../pages/LabDetails/CAVSTERReview";
import CAVSFRWReview from "../../pages/LabDetails/CAVSFRWReview";
import CAVSENVCostAndConfirm from "../../pages/LabDetails/CAVSENVCostAndConfirm";
import CAVSAVICostAndConfirm from "../../pages/LabDetails/CAVSAVICostAndConfirm";
import CAVSENVAcknowledgement from "../../pages/LabDetails/CAVSENVAcknowledgement";
import CAVSTERCostAndConfirm from "../../pages/LabDetails/CAVSTERCostAndConfirm";
import CAVSFRWCostAndConfirm from "../../pages/LabDetails/CAVSFRWCostAndConfirm";
import CAVSFRWAcknowledgement from "../../pages/LabDetails/CAVSAVIAcknowledgement";
import CAVSTERAcknowledgement from "../../pages/LabDetails/CAVSTERAcknowledgement";
import LabDashboard from "../../pages/LabDetails/LabDashboard";
import SaveDraftDashboard from "../../pages/LabDetails/SaveDraftDashboard";
import CopyLabApplicationDashboard from "../../pages/LabDetails/CopyLabApplicationDashboard";
import LabresultDashboard from "../../pages/LabDetails/Helper/LabresultDashboard";
import InvoiceDashboard from "../../pages/Payment/InvoiceDashboard";
import AcsApplicationForm from "../../pages/OtherServices/AcsApplicationForm";
//Lab Module End
// const UAT_AUTH_SCREEN moved into AppRoutes to read runtime config
const APP_ROUTES = [
  {
    path: "/",
    component: EServices,
  },
  {
    path: "/application-registration",
    component: ApplicationForBirds,
  },
  {
    path: "/Single-Reg-Complete",
    component: SingleRegComplete,
  },
  {
    path: "/EServices",
    component: EServices,
  },
  {
    path: "/auth",
    component: Auth,
  },
  {
    path: "/app-inspection",
    component: ApplicationForInspection,
  },

  {
    path: "/app-inspection-dashboard",
    component: InspectionDashboard,
  },
  {
    path: "/app-inspection-complete",
    component: HarvestInspectionComplete,
  },
  {
    path: "/application-for-pets",
    component: ApplicationForPets,
  },
  {
    path: "/app-harvest-dashboard",
    component: HarvestDetailsDashboard,
  },
  {
    path: "/harvest-details",
    component: HarvestDetails,
  },
  {
    path: "/harvest-microchipregistration",
    component: ApplicationForBirds,
  },
  {
    path: "/harvest-registration",
    component: HarvestDetailsRegistration,
  },
  {
    path: "/harvest-details-complete",
    component: HarvestDetailsApplicationComplete,
  },
  {
    path: "/isr-inspections",
    component: ISRInspection,
  },
  {
    path: "/isr-inspection-dashboard",
    component: ISRInspectionDashboard,
  },
  {
    path: "/vethealth-inspections",
    component: VetHealthInspection,
  },
  {
    path: "/vethealth-inspection-dashboard",
    component: VetHealthInspectionDashboard,
  },
  {
    path: "/vethealth-inspection-complete",
    component: VetHealthInspectionComplete,
  },
  {
    path: "/choose-application",
    component: ChooseApplication,
  },
  {
    path: "/samples-and-tests",
    component: SamplesAndTests,
  },
  {
    path: "/aqua-samples-and-tests",
    component: AquaSamplesAndTest,
  },
  {
    path: "/review",
    component: Review,
  },
  {
    path: "/aqua-review",
    component: CAVSAquaReview,
  },
  {
    path: "/bio-review",
    component: CAVSBioReview,
  },

  {
    path: "/avi-review",
    component: CAVSAVIReview,
  },
  {
    path: "/ter-review",
    component: CAVSTERReview,
  },
  {
    path: "/frw-review",
    component: CAVSFRWReview,
  },
  {
    path: "/env-review",
    component: CAVSENVReview,
  },
  {
    path: "/bio-cost-and-confirm",
    component: CAVSBioCostAndConfirm,
  },
  {
    path: "/ter-cost-and-confirm",
    component: CAVSTERCostAndConfirm,
  },
  {
    path: "/ENV-cost-and-confirm",
    component: CAVSENVCostAndConfirm,
  },
  {
    path: "/aqua-cost-and-confirm",
    component: CAVSAquaCostAndConfirm,
  },

  {
    path: "/env-cost-and-confirm",
    component: CAVSENVCostAndConfirm,
  },
  {
    path: "/avi-cost-and-confirm",
    component: CAVSAVICostAndConfirm,
  },
  {
    path: "/frw-cost-and-confirm",
    component: CAVSFRWCostAndConfirm,
  },
  {
    path: "/bio-acknowledgement",
    component: CAVSBioAcknowledgement,
  },
  {
    path: "/frw-acknowledgement",
    component: CAVSFRWAcknowledgement,
  },
  {
    path: "/env-acknowledgement",
    component: CAVSENVAcknowledgement,
  },
  {
    path: "/avi-acknowledgement",
    component: CAVSAVIAcknowledgement,
  },
  {
    path: "/aqua-acknowledgement",
    component: CAVSAquaAcknowledgement,
  },
  {
    path: "/ter-acknowledgement",
    component: CAVSTERAcknowledgement,
  },
  {
    path: "/bio-samples-and-tests",
    component: BioSamplesAndTest,
  },
  {
    path: "/aqua-samples-and-tests",
    component: AquaSamplesAndTest,
  },
  {
    path: "/project-details",
    component: ProjectDetails,
  },
  {
    path: "/cost-and-confirm",
    component: CostAndConfirm,
  },
  {
    path: "/acknowledgement",
    component: Acknowledgement,
  },
  {
    path: "/animal-purpose-code",
    component: AnimalPurposeCode,
  },
  {
    path: "/env-samples-and-tests",
    component: CAVSENVSampleDetails,
  },
  {
    path: "/avi-samples-and-tests",
    component: CAVSAVISampleDetails,
  },
  {
    path: "/lab-dashboard",
    component: LabDashboard,
  },
  {
    path: "/labresults-dashboard",
    component: LabresultDashboard,
  },
  {
    path: "/savedraft-dashboard",
    component: SaveDraftDashboard,
  },
  {
    path: "/copylab-dashboard",
    component: CopyLabApplicationDashboard,
  },
  {
    path: "/ter-samples-and-tests",
    component: CAVSTERSampleDetails,
  },
  {
    path: "/frw-samples-and-tests",
    component: CAVSFRWSampleDetails,
  },
  {
    path: "/frw-review",
    component: CAVSFRWReview,
  },
  {
    path: "/import-permit",
    component: ApplicationForImportPermit,
  },
  {
    path: "/application-membership",
    component: ApplicationForMembership,
  },
  {
    path: "/payment-dashboard",
    component: PaymentDashboard,
  },
  {
    path: PageUrl.CPLogin,
    component: CorppassLogin,
  },
  {
    path: PageUrl.MILogin,
    component: MyInfoLogin,
  },
  {
    path: PageUrl.CPCallback,
    component: AuthCallbackCP,
  },
  {
    path: PageUrl.MICallback,
    component: MIAuthCallback,
  },
  {
    path: PageUrl.Login,
    component: Login,
  },
  {
    path: PageUrl.SfaRegistration,
    component: SfaRegistration,
  },
  {
    path: PageUrl.SfaSuccess,
    component: SfaSuccess,
  },
  {
    path: "/payments",
    component: Payments,
  },
  {
    path: "/tradenet-payments",
    component: TradenetPayments,
  },
  {
    path: "/success",
    component: Success,
  },
  {  
    path: "/payment-failed",
    component: PaymentFailed,
  },
  {
    path: "/feedback",
    component: Feedback,
  },
  {
    path: "/userguides",
    component: UserGuides,
  },
  {
    path: "/rating-feedback",
    component: RatingFeedback,
  },
  {
    path: PageUrl.AccountRegistration,
    component: AccountRegistration,
  },
  {
    path: PageUrl.AccountSuccess,
    component: AccountSuccess,
  },
  {
    path: PageUrl.Profile,
    component: MyProfile,
  },
  {
    path: PageUrl.ForceChangePassword,
    component: ForceChangePassword,
  },
  {
    path: PageUrl.ResetPassword,
    component: ResetPassword,
  },
  {
    path: PageUrl.ForgetPassword,
    component: ForgetPassword,
  },
  {
    path: "/invoice-dashboard",
    component: InvoiceDashboard,
  },
  {
    path: "/acs-scheme",
    component: AcsApplicationForm,
  }
];

const AppRoutes = () => {
  const cfg = useConfig();
  const UAT_AUTH_SCREEN = cfg.REACT_APP_UAT_AUTH_SCREEN;
  const [cookies] = useCookies(["authtoken"]);
  let authenticated = false;

  if (UAT_AUTH_SCREEN === "NO") {
    authenticated = true;
  } else if (UAT_AUTH_SCREEN === "YES") {
    const userId = decryptData(cookies["authtoken"]);
    authenticated = Boolean(userId);
  }
  
  return (
    <Routes>
      {authenticated == false && (
        <Route path={PageUrl.Auth} caseSensitive={false} element={<Auth />} />
      )}
      {authenticated == false && <Route path="*" element={<Auth />} />}
      {authenticated == false && (
        <Route path={PageUrl.Home} caseSensitive={false} element={<Auth />} />
      )}
      {authenticated && (
        <Route path={PageUrl.Login} caseSensitive={false} element={<Login />} />
      )}
      {authenticated && (
        <Route
          path={PageUrl.CPLogin}
          caseSensitive={false}
          element={<CorppassLogin />}
        />
      )}
      {authenticated && (
        <Route
          path={PageUrl.MILogin}
          caseSensitive={false}
          element={<MyInfoLogin />}
        />
      )}
      {authenticated && (
        <Route
          path={PageUrl.MICallback}
          caseSensitive={false}
          element={<MIAuthCallback />}
        />
      )}
      {authenticated && (
        <Route
          path={PageUrl.CPCallback}
          caseSensitive={false}
          element={<AuthCallbackCP />}
        />
      )}
      {authenticated && (
        <Route
          path={PageUrl.SfaRegistration}
          caseSensitive={false}
          element={<SfaRegistration />}
        />
      )}
      {authenticated && (
        <Route
          path={PageUrl.SfaSuccess}
          caseSensitive={false}
          element={<SfaSuccess />}
        />
      )}
      {authenticated && (
        <Route
          path={PageUrl.AccountRegistration}
          caseSensitive={false}
          element={<AccountRegistration />}
        />
      )}
      {authenticated && (
        <Route
          path={PageUrl.AccountSuccess}
          caseSensitive={false}
          element={<AccountSuccess />}
        />
      )}
      {authenticated && (
        <Route
          path={PageUrl.ForgetPassword}
          caseSensitive={false}
          element={<ForgetPassword />}
        />
      )}
      {authenticated && (
        <Route
          path={PageUrl.ResetPassword}
          caseSensitive={false}
          element={<ResetPassword />}
        />
      )}
      {authenticated && (
        <Route
          path={PageUrl.Home}
          caseSensitive={false}
          element={<EServices />}
        />
      )}
      {authenticated && (
        <Route
          path={PageUrl.Userguide}
          caseSensitive={false}
          element={<UserGuides />}
        />
      )}
      {authenticated &&
        APP_ROUTES.map((route, index) => (
          <Route
            key={index}
            caseSensitive={false}
            element={
              <SecureRoute>
                <route.component />
              </SecureRoute>
            }
            path={route.path}
          />
        ))}
      {authenticated && <Route path="*" element={<NotFound />} />}
    </Routes>
  );
};

export default AppRoutes;
